<template>
  <div class="">
    <img v-if="staffRes.src" class="staff-img" :src="staffRes.src" alt="">
    <div v-else class="staff-img-default">{{nickName.nameStr}}</div>
    <span class="staff-name">{{nickName.name}}</span>
  </div>
</template>

<script>
  export default {
    name: "render-staff",
    props:{
      staffRes:{
        type:Object
      }
    },
    computed:{
      nickName(){
        let nameStr = ''
        if(!this.staffRes.src){
          nameStr = this.staffRes.name.substring(this.staffRes.name.length - 1, this.staffRes.name.length)
        }
        return {name:this.staffRes.name,nameStr}
      }
    }
  }
</script>

<style scoped>
  .staff-img{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .staff-name{
    margin-left:10px;
    vertical-align: middle;
  }
  .staff-img-default{
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #2db7f5;
    color: #FFF;
    text-align: center;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/view/home/function/render/render-staff.vue



// WEBPACK FOOTER //
// src/view/home/function/render/render-staff.vue